import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../components/Contact.css";

export default function CompletePage() {
  const navigate = useNavigate();

  return (
    <div className="contact-page-wrapper">
      <Container className="contact-container text-center">
        <h2>送信完了</h2>
        <p>お問い合わせありがとうございました。内容を確認の上、担当者よりご連絡いたします。</p>
        <Button onClick={() => navigate("/home")}>トップページへ戻る</Button>
      </Container>
    </div>
  );
}